export const multiLanguageStringQuery = `
  de
  en
`;
